import { render } from "./operators.vue?vue&type=template&id=50b60e88"
import script from "./operators.vue?vue&type=script&lang=js"
export * from "./operators.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__